
<template>
	<div class="footerWraper">
		

		<div class="footer">
			<div v-for='(item,index) of items' :class='[item.cls,{on:index === idx}]' @click="goUserinfo(item.push)">
				<img :src="index===idx?item.iconSelect:item.icon" class="icon">
				<p :class="['colorChange',{on:index===idx}]" >{{item.name}}</p>
			</div>

		</div>
	</div>
</template>

<script type="text/javascript">

export default{
	name:'navBar',
	props:['idx'],
	data(){
		return {
			items:[{
				cls:"home",
				name:"首页",
				push:"/",
				icon:"/static/images/home.png",
				iconSelect:"/static/images/home_red.png"
			},
			{
				cls:"order",
				name:"订单",
				push:"/historycard",
				icon:"/static/images/dingdan.png",
				iconSelect:"/static/images/dingdan_red.png"
			},
			{
				cla:"customer",
				name:"客服",
				push:"/customer",
				icon:"/static/images/kefu.png",
				iconSelect:"/static/images/kefu_red.png"
			},
			{
				cla:"mine",
				name:"我的",
				push:"/mine",
				icon:"/static/images/mine.png",
				iconSelect:"/static/images/mine_red.png"
			}]
		}
	},


	methods:{
		goUserinfo(t){
         this.$router.push(
            t,
            onComplete => {},
            onAbort => {}
         )
      }
	}

} 

</script>
<style scoped>
.footerWraper{
	position: fixed;
	bottom:0;
	max-width: 750px;
	width:100%;
	height: 60px;
	left:50%;
	right:0;
	transform:translateX(-50%);
	z-index:999;
	font-size: 14px;

}
.footer{
	width: 100%;
	height: 60px;
	display:flex;
	flex-direction:row;
	justify-content:space-around;
	background-color:#fff;
  border-top: 1px solid #DDDDDD;
}

.footer div{
	width:25%;
	overflow:hidden;
}
.icon{
	width:1.5rem;
	height: 1.5rem;
	margin-top: .5em;
}
.footer p{
	margin-top:0;
	margin-bottom:0.5em;
	font-size: 14px;
}
.colorChange.on{
	color:#b22830;
}
</style>


// WEBPACK FOOTER //
// src/components/navBar.vue